/**
 * Inspector Controls 공유 디자인 토큰
 *
 * ValueInputField, ColorInputField, SelectFieldTrigger가
 * 동일한 시각 스타일을 유지하기 위한 공유 토큰.
 *
 * 높이/패딩/곡률/배경/간격 등 디자인 변경 시 이 파일만 수정하면
 * 세 컴포넌트에 일괄 반영됩니다.
 *
 * ⚠️ Tailwind 호환 주의:
 * 셀렉터 프리픽스(hover:, data-[]:, has-[] 등)가 필요한 상태 클래스는
 * 각 컴포넌트에서 인라인 리터럴로 작성해야 합니다.
 * 여기서는 셀렉터 없이 사용 가능한 토큰만 제공합니다.
 */
export const InspectorControlsStyles = {
  /** 컨테이너 기본 시각 스타일 (높이/패딩/곡률/배경/간격) */
  container:
    'flex min-h-[36px] items-center transition-all duration-200 ease-out px-xs py-3xs rounded-2xs border-0 bg-sys-style-neutral-lightest box-border min-w-0 gap-4xs',

  /** Leading Node */
  leadingNode: {
    base: 'flex size-[20px] flex-shrink-0 items-center justify-center',
    icon: '[&_path]:fill-sys-cont-neutral-default',
    iconDisabled: 'opacity-50 [&_path]:fill-sys-cont-neutral-disabled-light',
    colorChip:
      'box-border size-[20px] flex-shrink-0 rounded-3xs border border-sys-style-neutral-deep',
    colorChipDisabled: 'opacity-50',
  },

  /** 값 텍스트 */
  value: {
    base: 'flex-1 text-comp-moderate-medium',
    filled: 'text-sys-cont-neutral-default',
    placeholder: 'text-sys-cont-neutral-disabled-default',
    disabled: 'text-sys-cont-neutral-disabled-light',
  },

  /** Chevron (ArrowDropDown) 아이콘 */
  chevron: {
    base: 'size-[16px] transition-transform duration-200 ease-out [&_path]:fill-sys-cont-neutral-default',
    open: 'rotate-180',
    disabled: '[&_path]:fill-sys-cont-neutral-disabled-light',
  },

  /** 레이블 */
  label: {
    wrapper: 'text-caption-small',
    text: 'flex items-center gap-5xs text-sys-cont-neutral-light transition-all',
    disabled: 'text-sys-cont-neutral-disabled-light',
  },
} as const;
